/* eslint-disable react/no-danger */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import Collapsible from '../collapsible/Collapsible';
import PulpoField from '../../pulpo_visualizer/fields';
import MultiColumnGrid from '../../modules/forms/MultiColumnGrid';
import styles from './custom.module.scss';
import Attachments from '../../modules/forms/components/Attachments';

const DEFAULT_FIELD_MAP = {
  default_location: 'location',
  default_preferences: 'size_preference'
};

function getDefaultFieldValue(key, answers, info) {
  if (answers && answers[key] !== undefined) return answers[key];
  if (info && info[key] !== undefined) return info[key];

  const mappedKey = DEFAULT_FIELD_MAP[key];
  if (mappedKey) {
    if (answers && answers[mappedKey] !== undefined) return answers[mappedKey];
    if (info && info[mappedKey] !== undefined) return info[mappedKey];
  }
  return undefined;
}
class customFields extends Component {
    checkConditionalValue = (field) => {
      const { answers, info, isWaitListCreate, hazardInfo, enableThirdLevel, checkCategories } = this.props;
      const controllingKey = field?.conditional_field?.key;
      let controllingValue;

      if (isWaitListCreate) {
        controllingValue = getDefaultFieldValue(controllingKey, answers, info);
      } else {
        controllingValue = answers?.[controllingKey] ?? info?.[controllingKey];
      }
      let isValue = false;
      if (typeof controllingValue === 'string') {
        isValue = field?.conditional_values.some(
        value => controllingValue === value.value
        );
    } else if (Array.isArray(controllingValue)) {
        isValue = field?.conditional_values.some(
        value => controllingValue.indexOf(value.value) !== -1
        );
    } else if (typeof controllingValue === 'object' && controllingValue?.level_1) {
        isValue = Object.values(controllingValue)
        ?.filter(value => value !== '')
        ?.join()
        === Object.values(field.conditional_values[0])
        ?.filter(value => value !== '')
        ?.join();
    } else if (typeof controllingValue === 'boolean') {
        isValue = field?.conditional_values.some(
        value => (
            controllingValue.toString() === value?.value
        )
        );
    } else if (checkCategories && field?.conditional_field?.key === 'default_category') {
        const cond = field?.conditional_values || [];

        const selectedCategories = cond?.[0]?.default_category || [];
        const selectedSubCategories = cond?.[1]?.default_sub_category || [];
        const selectedSubCategories2 = cond?.[2]?.default_sub_category_2 || [];
        let isCategoryMatch = false;
        let isSubCategoryMatch = !selectedSubCategories.length || false;
        let isSubCategory2Match = (!enableThirdLevel || !selectedSubCategories2.length);
        if (selectedCategories.length) {
          isCategoryMatch = selectedCategories.every(value => (hazardInfo?.category || []).includes(value));
        }

        if (selectedSubCategories.length) {
            isSubCategoryMatch = selectedSubCategories.every(value => (hazardInfo?.sub_category || []).includes(value));
        }

        if (selectedSubCategories2.length && enableThirdLevel) {
            isSubCategory2Match = selectedSubCategories2.every(value => (hazardInfo?.sub_category_2 || []).includes(value));
        }
        isValue = isCategoryMatch && isSubCategoryMatch && isSubCategory2Match;
      }
      return isValue;
    };

  render() {
    const {
      handleAnswerChanged,
      answers,
      showFormErrors,
      handleFieldErrorChanged,
      airport_data,
      requiredMap,
      fields,
      orderField,
      forSmsPublic,
      datasources,
      selectedLang,
      sms_form,
        handleUploadAttachments,
        errorListMCG,
        allDataSources,
        dataSourceValues,
        user,
        isFromSms
    } = this.props;

    const getTitle = field => (
        (selectedLang && selectedLang!== '' && field?.meta_data && field?.meta_data?.[selectedLang]
            && field?.meta_data[selectedLang]?.name) ? field?.meta_data[selectedLang]?.name : field?.title
    );
    const getDescription = field => ((selectedLang && selectedLang !== '' && field?.meta_data?.[selectedLang]?.description)
    ? field?.meta_data?.[selectedLang]?.description : `${field?.description || ''}`);
    return (
      <>
        {requiredMap && fields.map(field => (
            <>
                {(orderField === field?.id || !orderField) && !field.conditional && (
                    <>
                        {field.type === 'header' && (!field.enable_rte || field.enable_rte === false) && (
                            <>
                                {field.collapsible ? (
                                    <div className={styles.collapseHeader}>
                                    <Collapsible
                                        title={getTitle(field)} openOnMount
                                        styleClasses={styles.header}
                                    >
                                        <div>
                                            <pre className={styles.description}>
                                                {getDescription(field)}
                                            </pre>
                                        </div>
                                    </Collapsible>
                                    </div>
                                ): (
                                    <>
                                        <div className={styles.header}>
                                            {getTitle(field)}
                                        </div>
                                        <div>
                                            <pre className={styles.description}>
                                                {getDescription(field)}
                                            </pre>
                                        </div>
                                    </>
                                )}
                            </>
                        )}
                        {field.type === 'header' && field.enable_rte === true && (
                            <>
                                {field.collapsible ? (
                                    <div className={styles.collapseHeader}>
                                    <Collapsible
                                        title={field.title} openOnMount
                                        styleClasses={styles.header}
                                    >
                                        <div>
                                            <pre className={styles.description} dangerouslySetInnerHTML={{ __html: field.rte_description }} />
                                        </div>
                                    </Collapsible>
                                    </div>
                                ): (
                                    <>
                                        <div className={styles.header}>
                                            {getTitle(field)}
                                        </div>
                                        <div>
                                            <pre className={styles.description} dangerouslySetInnerHTML={{ __html: field.rte_description }} />
                                        </div>
                                    </>
                                )}
                            </>
                        )}
                        {field.type === 'attachments' && (
                            <Attachments
                                {...field}
                                handleAnswerChanged={handleAnswerChanged}
                                attachments={answers && answers[field.id]}
                                showFieldErrors={showFormErrors}
                                handleFieldErrorChanged={handleFieldErrorChanged}
                                title={getTitle(field)}
                            />
                        )}
                        {field.type === 'map_location' && (
                            <PulpoField key={field.id} {...field} airportInfo={airport_data}
                                handleValueChange={handleAnswerChanged}
                                isRequired={requiredMap[field.id]} answer={answers[field.id]}
                                showFieldErrors={showFormErrors}
                                handleFieldErrorChanged={handleFieldErrorChanged}
                                className={styles.fullWidth} addressEnabled={field?.address_location}
                                title={field?.address_location ? 'Address' : getTitle(field)}
                                translationID={field?.address_location ? 'custom_field.address.title' : getTitle(field)}
                                locationId={field.title}
                                locationTitle={field.title}
                                description={getDescription(field)}
                                sms_form={sms_form}
                            />
                        )}
                        {field.type !== 'header' && field.type !== 'page_break' && field.type !== 'attachments' && field.type !== 'map_location'
                         && field.type !== 'multi_level' && (field.type !== 'ssi_field' && field.disable_for_portal !== true)
                         && field?.type !== 'multi_field' && (
                            <PulpoField key={field.id} {...field} onlyTime={field.type === 'time'}
                                values={(selectedLang && selectedLang!== '' && field?.meta_data && field?.meta_data?.[selectedLang]
                                    && field?.meta_data[selectedLang]?.dropdownOptions && field?.meta_data[selectedLang]?.dropdownOptions?.length > 0
                                    ? field?.meta_data[selectedLang]?.dropdownOptions?.map(((o, i) => ({
                                    key: `${i}`,
                                    value: o
                                    }))) : field?.values)
                                }
                                translation={getTitle(field)}
                                handleValueChange={handleAnswerChanged}
                                isRequired={requiredMap[field.id]} answer={answers[field.id]}
                                showFieldErrors={showFormErrors}
                                handleFieldErrorChanged={handleFieldErrorChanged}
                                className={field.full_width ? styles.fullWidth : ''} customField
                                forSmsPublic={forSmsPublic}
                                datasources={datasources}
                                description={getDescription(field)}
                                noDefault={(field.type === 'time' || field.type.includes('date')) && !field?.default} />
                        )}
                        {field?.type === 'multi_field' && (
                            <MultiColumnGrid
                                currentField={field}
                                handleAnswerChanged={handleAnswerChanged}
                                answers={answers}
                                selectedLang={selectedLang}
                                handleUploadAttachments={handleUploadAttachments}
                                flexWrap
                                disabled={field.disable_for_portal}
                                showFormErrors={showFormErrors}
                                errorListMCG={errorListMCG}
                                allFields={fields}
                                from={'from'}
                                handleFieldErrorChanged={handleFieldErrorChanged}
                                allDataSources={allDataSources}
                                dataSourceValues={dataSourceValues}
                                user={user}
                                isFromSms={isFromSms}
                            />
                        )}
                        { field?.type === 'multi_level'
                        && <>
                      {/* don't even change the props passing position here,
                           it will raise not displaying or page break issues */}
                            <PulpoField
                                {...field}
                                levels={{
                                level_0: {
                                    title: selectedLang && selectedLang !==''
                                        && field?.meta_data?.[selectedLang]?.multiLevelTitles?.level_1 || `${field?.title}`
                                },
                                level_1: {
                                    title: selectedLang && selectedLang !==''
                                        && field?.meta_data?.[selectedLang]?.multiLevelTitles?.level_2 || `${field?.title} 1`
                                },
                                level_2: {
                                    title: selectedLang && selectedLang !==''
                                        && field?.meta_data?.[selectedLang]?.multiLevelTitles?.level_3 ||`${field?.title} 2`
                                }
                                }}
                                title={getTitle(field)}
                                description={getDescription(field)}
                                forSmsPublic={forSmsPublic}
                                values={typeof field.values === 'object'
                                ?Object.values(field.values).map(item => ({ ...item, name: item.title })):[]}
                                handleValueChange={handleAnswerChanged}
                                handleFieldErrorChanged={handleFieldErrorChanged}
                                isRequired={requiredMap[field.id]}
                                showFieldErrors={showFormErrors}
                                forFormModule
                                answer={answers && answers[field.id]}
                                type="dataSourceMultiLevel"
                            />
                           </>
                        }
                    </>
                )}
                {(orderField === field?.id || !orderField) && field.conditional
                && this.checkConditionalValue(field) && (
                    <>
                        {field.type === 'header' && (!field.enable_rte || field.enable_rte === false) && (
                            <>
                                {field.collapsible ? (
                                    <div className={styles.collapseHeader}>
                                    <Collapsible
                                        title={getTitle(field)} openOnMount
                                        styleClasses={styles.header}
                                    >
                                        <div>
                                            <pre className={styles.description}>
                                                {getDescription(field)}
                                            </pre>
                                        </div>
                                    </Collapsible>
                                    </div>
                                ): (
                                    <>
                                        <div className={styles.header}>
                                            {getTitle(field)}
                                        </div>
                                        <div>
                                            <pre className={styles.description}>
                                                {getDescription(field)}
                                            </pre>
                                        </div>
                                    </>
                                )}
                            </>
                        )}
                        {field.type === 'header' && field.enable_rte === true && (
                            <>
                                {field.collapsible ? (
                                    <div className={styles.collapseHeader}>
                                    <Collapsible
                                        title={getTitle(field)} openOnMount
                                        styleClasses={styles.header}
                                    >
                                        <div>
                                            <pre className={styles.description} dangerouslySetInnerHTML={{ __html: field.rte_description }} />
                                        </div>
                                    </Collapsible>
                                    </div>
                                ): (
                                    <>
                                        <div className={styles.header}>
                                            {getTitle(field)}
                                        </div>
                                        <div>
                                            <pre className={styles.description} dangerouslySetInnerHTML={{ __html: field.rte_description }} />
                                        </div>
                                    </>
                                )}
                            </>
                        )}
                        {field.type === 'attachments' && (
                            <Attachments
                                {...field}
                                handleAnswerChanged={handleAnswerChanged}
                                attachments={answers && answers[field.id]}
                                showFieldErrors={showFormErrors}
                                handleFieldErrorChanged={handleFieldErrorChanged}
                                title={getTitle(field)}
                            />
                        )}
                        {field.type === 'map_location' && (
                            <PulpoField key={field.id} {...field} airportInfo={airport_data}
                                handleValueChange={handleAnswerChanged}
                                isRequired={requiredMap[field.id]} answer={answers[field.id]}
                                showFieldErrors={showFormErrors}
                                handleFieldErrorChanged={handleFieldErrorChanged}
                                className={styles.fullWidth} addressEnabled={field?.address_location}
                                title={field?.address_location ? 'Address' : getTitle(field)}
                                translationID={field?.address_location ? 'custom_field.address.title' : getTitle(field)}
                                locationId={field.title}
                                locationTitle={field.title}
                                description={getDescription(field)}
                                sms_form={sms_form}
                            />
                        )}
                        {field.type !== 'header' && field.type !== 'page_break' && field.type !== 'attachments' && field.type !== 'map_location'
                         && field.type !== 'multi_level' && field?.type !== 'multi_field' && (
                            <PulpoField key={field.id} {...field} onlyTime={field.type === 'time'}
                                translation={getTitle(field)} handleValueChange={handleAnswerChanged}
                                isRequired={requiredMap[field.id]} answer={answers[field.id]}
                                showFieldErrors={showFormErrors}
                                handleFieldErrorChanged={handleFieldErrorChanged}
                                className={field.full_width ? styles.fullWidth : ''} customField
                                datasources={datasources}
                                forSmsPublic={forSmsPublic}
                                description={getDescription(field)}
                                noDefault={(field.type === 'time' || field.type.includes('date')) && !field?.default}
                            />
                        )}
                        { field?.type === 'multi_level'
                        && <>
                      {/* don't even change the props passing position here,
                           it will raise not displaying or page break issues */}
                            <PulpoField
                                {...field}
                                levels={{
                                level_0: {
                                    title: selectedLang && selectedLang !==''
                                    && field?.meta_data?.[selectedLang]?.multiLevelTitles?.level_1 || `${field?.title}`
                                },
                                level_1: {
                                   title: selectedLang && selectedLang !==''
                                    && field?.meta_data?.[selectedLang]?.multiLevelTitles?.level_2 || `${field?.title} 1`
                                },
                                level_2: {
                                     title: selectedLang && selectedLang !==''
                                    && field?.meta_data?.[selectedLang]?.multiLevelTitles?.level_3 || `${field?.title} 2`
                                }
                                }}
                                title={getTitle(field)}
                                description={getDescription(field)}
                                forSmsPublic={forSmsPublic}
                                values={typeof field.values === 'object'
                                ?Object.values(field.values).map(item => ({ ...item, name: item.title })):[]}
                                handleValueChange={handleAnswerChanged}
                                handleFieldErrorChanged={handleFieldErrorChanged}
                                isRequired={requiredMap[field.id]}
                                showFieldErrors={showFormErrors}
                                forFormModule
                                answer={answers && answers[field.id]}
                                type="dataSourceMultiLevel"
                            />
                           </>
                        }
                        {field?.type === 'multi_field' && (
                            <MultiColumnGrid
                                currentField={field}
                                handleAnswerChanged={handleAnswerChanged}
                                answers={answers}
                                handleUploadAttachments={handleUploadAttachments}
                                flexWrap
                                selectedLang={selectedLang}
                                disabled={field.disable_for_portal}
                                showFormErrors={showFormErrors}
                                errorListMCG={errorListMCG}
                                allFields={fields}
                                from={'from'}
                                handleFieldErrorChanged={handleFieldErrorChanged}
                                allDataSources={allDataSources}
                                dataSourceValues={dataSourceValues}
                                user={user}
                                isFromSms={isFromSms}
                            />
                        )}
                    </>
                )}
            </>
        ))}
      </>
    );
  }
}

customFields.propTypes = {
  handleAnswerChanged: PropTypes.func.isRequired,
  answers: PropTypes.shape({}).isRequired,
  handleFieldErrorChanged: PropTypes.func.isRequired,
  showFormErrors: PropTypes.bool.isRequired
};


export default withRouter(customFields);
